import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/login/index.vue';
import Dashboard from './views/dashboard/index.vue';
import dashboardRoutes from './views/dashboard/router.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', component: Login },
    { path: '/dashboard', component: Dashboard, children: dashboardRoutes },
    { path: '/', redirect: '/dashboard' }
  ]
});

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/dashboard') && !localStorage.getItem('token')) {
    next('/login');
  } else {
    next();
  }
});

export default router; 